import React from 'react';

function Stocks() {
  return (
    <div className="page-centered-container" style={{textAlign:'center',marginTop:'40px'}}>
      <h1><i className="fa fa-archive icon-blue icon-lg mr-8"></i>Gestion des stocks</h1>
      <div style={{marginTop:'32px',fontSize:'1.2em',color:'#888',fontWeight:500}}>
        Cette page n'est pas disponible pour l'instant.<br/>
        Elle est en cours de développement.
      </div>
    </div>
  );
}

export default Stocks;
